import { all, fork, take } from 'redux-saga/effects';
import { reduxModuleLoaded } from '../actions';
import init from './init';
import layout from './layout';
import modules from './modules';
export default function* rootSaga() {
    yield take(reduxModuleLoaded); // wait for redux to load
    yield all([
        fork(init),
        fork(layout),
        fork(modules)
    ]);
}
